export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/linkedin.78ff616.svg";